var map = {
	"./cricket_summaryLive.json": 766,
	"./cricket_summaryLive2.json": 767
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 765;



//////////////////
// WEBPACK FOOTER
// ../mock-data ^\.\/.*$
// module id = 765
// module chunks = 0